import assetPath from '/app/packages/lebenslauf/articles/src/assets/erfolgreiche-interne-bewerbung-tipp.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')